import React from 'react';
import classNames from 'classnames';
import { buildHandleEnterKeyPress } from 'utils/a11y';

const PageLink = ({ selected, className, link, onClick, pageNumber }) => {
  const styleName = classNames('Pagination-pageLink', {
    'Pagination-pageLink--selected': selected,
    [className]: true,
  });

  return (
    <li className={styleName}>
      <a
        tabIndex="0"
        href={link}
        role="button"
        onClick={onClick}
        onKeyPress={buildHandleEnterKeyPress(onClick)}
        aria-label={`${t('pagination.page')} ${pageNumber}`}
      >
        {pageNumber}
      </a>
    </li>
  );
};

export default PageLink;
